//import BackArrowSvg from "@/public/ArrowBack.svg";
"use client";
import DropDownMenu from '@/components/framework/DropDownMenu';
import Hotlink from '@/components/framework/Hotlink';
import SCloseButton from "@/components/framework/SCloseButton";
import CMSImage from '@/components/images/Image';
import type { ICommonAppData } from '@/lib/types/sanity';
import type { Hotlink as NavHotLink } from '@/lib/types/Settings';
import ForsidenIcon from "@/svg/ForsidenIcon";
import classNames from "classnames";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import type { CSSProperties} from "react";
import { useEffect, useState } from "react";
import styles from "./Menu.module.css";



//#region [Props]
type MenuProps = {
    appData: ICommonAppData;
    className?: string;
};
//#endregion

//#region [Component]  Menu
const Menu = ({ appData, className }: MenuProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const pathname = usePathname();
    const queryParams = useSearchParams();

    useEffect(() => {
        setIsOpen(false);
    }, [pathname, queryParams]);

    const settings = appData?.settings;
    if (!settings) {
        return null;
    }

    const isLogoCentered = settings.centerLogo && (settings.hotlinks?.length ?? 0) === 0;

    return (<>
        <header className={classNames(styles.Header, className)}>
            <div className={styles.MenuContainer}>
                {settings.logo &&

                    <Link href="/" className={classNames(styles.LogoLink, isLogoCentered ? styles.LogoLink_centeredLogo : null)} aria-label="Gå til forsiden">
                        <CMSImage appData={appData} className={styles.LogoImage} image={settings.logo} altText={settings.cinemaName} priority unoptimized width={1000} />
                    </Link>
                }
                <div className={classNames(styles.MenuLinks, isLogoCentered ? styles.MenuLinks_centeredLogo : null)} >
                    {settings.hotlinks?.map(hotlink => <Hotlink key={hotlink._key} hotlink={hotlink} $hideOnSmallScreens useAnchors={settings.program_view === "none"} />)}
                    <SCloseButton $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>Meny</SCloseButton>
                </div>
            </div>
            {appData.menu?.dropDownMenu && <DropDownMenu isOpen={isOpen} setIsOpen={setIsOpen} menuItems={appData.menu.dropDownMenu} hotlinks={settings.hotlinks!} useAnchors={settings.program_view === "none"} />}

        </header>

        {settings.hotlinks && <NavHotBar hotlinks={settings.hotlinks!} useAnchors={settings.program_view === "none"} />}
    </>);

};

export default Menu;
//#endregion


//#region [Props]
type NavHotBarProps = {
    hotlinks: NavHotLink[];
    useAnchors?: boolean;
};
//#endregion

//#region [Component]
function NavHotBar({ hotlinks, useAnchors = false }: NavHotBarProps) {
    return <nav className={styles.MobileMenu} style={{ "--num-items": hotlinks.length + 1 } as CSSProperties}>
        <Link href="/">
            <ForsidenIcon />
            Forsiden
        </Link>
        {hotlinks.map(hotlink => <Hotlink key={hotlink._key} hotlink={hotlink} useAnchors={useAnchors} />)}
    </nav>
}
//#endregion